import type { ReviewBoqItem, MatchSummary } from '../../types';

interface PublishPreviewProps {
  items: ReviewBoqItem[];
  summary: MatchSummary | null;
  type: 'diagrams' | 'plans';
  onConfirm: () => void;
  onCancel: () => void;
}

export function PublishPreviewModal({ items, summary, type, onConfirm, onCancel }: PublishPreviewProps) {
  const unmatched = items.filter((i) => !i.lvMatch);
  const lowConf = items.filter((i) => i.lvMatch?.confidence === 'low');
  const qtyFlags = items.filter((i) => i.lvMatch?.quantityFlag);
  const hasWarnings = unmatched.length > 0 || lowConf.length > 0 || qtyFlags.length > 0;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-card publish-preview-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Publish {type === 'diagrams' ? 'Diagrams' : 'Plans'}</h2>

        {/* Stats */}
        <div className="publish-preview-stats">
          <div className="publish-preview-stat">
            <span className="publish-preview-stat-value">{items.length}</span>
            <span className="dim">Total items</span>
          </div>
          {summary && (
            <>
              <div className="publish-preview-stat">
                <span className="publish-preview-stat-value review-confidence-high">{summary.matchedHigh}</span>
                <span className="dim">High</span>
              </div>
              <div className="publish-preview-stat">
                <span className="publish-preview-stat-value review-confidence-medium">{summary.matchedMedium}</span>
                <span className="dim">Medium</span>
              </div>
              <div className="publish-preview-stat">
                <span className="publish-preview-stat-value review-confidence-low">{summary.matchedLow}</span>
                <span className="dim">Low</span>
              </div>
              <div className="publish-preview-stat">
                <span className="publish-preview-stat-value">{summary.unmatched}</span>
                <span className="dim">Unmatched</span>
              </div>
            </>
          )}
        </div>

        {/* Warnings */}
        {hasWarnings && (
          <div className="publish-preview-warnings">
            {unmatched.length > 0 && (
              <div className="publish-preview-warning">
                <span className="publish-preview-warning-icon">&#9888;</span>
                <span>{unmatched.length} item{unmatched.length !== 1 ? 's' : ''} not matched to any LV position</span>
              </div>
            )}
            {lowConf.length > 0 && (
              <div className="publish-preview-warning">
                <span className="publish-preview-warning-icon">&#9888;</span>
                <span>{lowConf.length} low-confidence match{lowConf.length !== 1 ? 'es' : ''}</span>
              </div>
            )}
            {qtyFlags.length > 0 && (
              <div className="publish-preview-warning">
                <span className="publish-preview-warning-icon">&#9888;</span>
                <span>{qtyFlags.length} quantity mismatch{qtyFlags.length !== 1 ? 'es' : ''}</span>
              </div>
            )}
          </div>
        )}

        <div className="modal-actions">
          <button className="btn-reject" onClick={onCancel}>Cancel</button>
          <button className="btn-approve" onClick={onConfirm}>Confirm Publish</button>
        </div>
      </div>
    </div>
  );
}
